import styled from "styled-components";
import { BASIC_DARK_GRAY, BASIC_LINE } from "../../../constants/colors";
import { useAsset } from "../../../hooks/useAsset";
import { Button } from "../../atoms/Button";
import { useCustomerInfoConfirmation } from "./hook";

export const CustomerInfoConfirmation: React.FC = () => {
  const { showSms } = useAsset();
  const {
    name,
    phoneNumber,
    email,
    password,
    handleRegisterUser,
    handleRegisterUserMail,
    handleGoBack,
  } = useCustomerInfoConfirmation();

  return (
    <Container>
      <TitleWrapper>お客さま情報の確認</TitleWrapper>

      <Message>
        登録内容に間違いがなければ「登録内容を送信する」をボタンをクリックしてください
      </Message>

      <InfoContainer>
        <LabelWrapper>
          <Label>名前</Label>
        </LabelWrapper>
        <InfoWrapper>
          <Label data-wovn-ignore>{name}</Label>
        </InfoWrapper>
      </InfoContainer>

      <InfoContainer>
        <LabelWrapper>
          <Label>電話番号</Label>
        </LabelWrapper>
        <InfoWrapper>
          <Label data-wovn-ignore>{phoneNumber}</Label>
        </InfoWrapper>
      </InfoContainer>

      {showSms && (
        <InfoContainer>
          <LabelWrapper>
            <Label>メールアドレス</Label>
          </LabelWrapper>
          <InfoWrapper>
            <Label data-wovn-ignore>{email}</Label>
          </InfoWrapper>
        </InfoContainer>
      )}

      <TitleWrapper2>パスワード</TitleWrapper2>
      <InfoContainer>
        <LabelWrapper>
          <Label>パスワード</Label>
        </LabelWrapper>
        <InfoWrapper>
          <PasswordLabel data-wovn-ignore>
            {password?.replace(/./g, "•")}
          </PasswordLabel>
        </InfoWrapper>
      </InfoContainer>

      <ButtonWrapper>
        <Button
          btnStyle="primary"
          text="登録内容を送信する"
          onClick={showSms ? handleRegisterUser : handleRegisterUserMail}
          rounded="md"
        />
        <Button
          btnStyle="secondary"
          text="修正する"
          onClick={handleGoBack}
          rounded="md"
        />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px;
  margin: 0 auto 80px;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  font-weight: 500;
  padding: 43px 0 38px 0;
  display: flex;
  line-height: 1;
  justify-content: center;
  font-family: "Hiragino Sans";
`;

const TitleWrapper2 = styled.div`
  font-size: 20px;
  font-weight: 600;
  padding: 12px 0 24px 0;
  display: flex;
  line-height: 1;
  justify-content: center;
  font-family: "Hiragino Sans";
`;

const Message = styled.p`
  font-size: 16px;
  font-weight: 300;
  line-height: 1.3em;
  text-align: left;
  margin-bottom: 26px;
  font-family: "Hiragino Sans";
`;

const InfoContainer = styled.div`
  text-align: left;
  margin-bottom: 20px;
  width: 100%;
`;

const LabelWrapper = styled.div`
  width: 100%;
  font-weight: 600;
  border-bottom: 1px solid ${BASIC_LINE};
`;

const InfoWrapper = styled.div`
  font-size: 16px;
  line-height: 40px;
  font-weight: 300;
  margin-top: 6px;
`;

const Label = styled.label`
  font-size: 16px;
  line-height: 34px;
  width: 100%;
  font-family: "Hiragino Sans";
`;

const PasswordLabel = styled.div`
  font-size: 26px;
  line-height: 1, 4em;
  font-weight: 300;
  font-weight: 500;
  letter-spacing: -6px;
  font-family: "Hiragino Sans";
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  margin: 44px 0 23px;
  flex-wrap: wrap;
  button {
    height: auto;
    line-height: 1;
    font-weight: 600;
  }

  @media (max-width: 980px) {
    gap: 16px;
  }
`;
